import React from "react";
import { IIconProps } from "./Icon/Interfaces";

const EllipsisIcon = ({
  width = 24,
  height = 6,
  strokeColor = "var(--classic-gray)",
}: IIconProps) => {
  return (
    <svg
      viewBox="0 0 24 6"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        r="2.5"
        transform="matrix(0 -1 -1 0 20.866 3)"
        fill={strokeColor}
      />
      <circle
        r="2.5"
        transform="matrix(0 -1 -1 0 11.866 3)"
        fill={strokeColor}
      />
      <circle 
        r="2.5" 
        transform="matrix(0 -1 -1 0 2.866 3)" 
        fill={strokeColor}
      />
    </svg>
  );
};

export default EllipsisIcon;
